import { Link } from "react-router-dom";

const SP_LOGO = "https://customer-assets.emergentagent.com/job_emt-task-check/artifacts/gaylzcdf_SP%20Logo%20Main.jpg";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-16 py-10 px-6" style={{ background: "#0d0d0d" }}>
      <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src={SP_LOGO} alt="StagePass" className="w-8 h-8 rounded-xl object-cover" />
            <span className="font-heading font-black text-white text-base">STAGEPASS</span>
          </div>
          <p className="text-zinc-500 text-sm leading-relaxed mb-3">You're not posting. You're premiering.</p>
          <p className="text-zinc-600 text-xs">Global Creator Broadcast Network</p>
        </div>

        <div>
          <p className="text-zinc-400 text-[10px] font-semibold uppercase tracking-widest mb-3">Platform</p>
          <ul className="space-y-2">
            <li><Link to="/" className="text-zinc-500 text-sm hover:text-white transition-colors">Feed</Link></li>
            <li><Link to="/explore" className="text-zinc-500 text-sm hover:text-white transition-colors">Explore</Link></li>
            <li><Link to="/radio" className="text-zinc-500 text-sm hover:text-white transition-colors">Radio</Link></li>
            <li><Link to="/live" className="text-zinc-500 text-sm hover:text-white transition-colors">Live</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-zinc-400 text-[10px] font-semibold uppercase tracking-widest mb-3">Legal</p>
          <ul className="space-y-2">
            <li><Link to="/privacy" className="text-zinc-500 text-sm hover:text-white transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-zinc-500 text-sm hover:text-white transition-colors">Terms of Service</Link></li>
          </ul>
        </div>
      </div>

      <div className="max-w-5xl mx-auto mt-8 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-zinc-600 text-xs">&copy; {new Date().getFullYear()} StagePass Access. All rights reserved.</p>
        <p className="text-zinc-700 text-xs">
          Built with <a href="https://app.emergent.sh" target="_blank" rel="noopener noreferrer" className="text-zinc-600 hover:text-zinc-400 transition-colors">Emergent</a>
        </p>
      </div>
    </footer>
  );
}
